const URL = 'https://foutalib-com.onrender.com/';
const allAdminProductsURL = `${URL}all-product`;
const productsURL = `${URL}product`;
const registerURL =`${URL}register-user`;
const loginURL = `${URL}login`;
const addProductURL = `${URL}add-product`;
const categoryURL = `${URL}category`;
const ImageURL = `${URL}images/`;
const mainImageURI = `${URL}image/`;
const ImagePathURI = `${URL}image-pah`;
const prodcutReviewURL = `${URL}review/`;
const addCartURL = `${URL}cart-add`;
const CartURL = `${URL}cart/`;
const deleteCart = `${URL}cart-delete/`;
const addOrderURL = `${URL}order-add`;
const orderURL = `${URL}order/`;
const deleteOrderURL = `${URL}order-delete/`;
const searchURL = `${URL}search`;
const vendorProductURL = `${URL}vendorsproduct/`;
const addPaymentURL = `${URL}add-payment`;
const updateCart = `${URL}cart-update/`; 
const paymentURL = `${URL}payment/`
const avatarURL = `${URL}avatar/`
const addAvatarURL = `${URL}avatar-upload/`
const vendorUrl = `${URL}vendor/`
const addFavoriteUrl = `${URL}add-favorite`
const favoriteUrl = `${URL}favorite/`
const favoriteDelete = `${URL}delete-favorite/`
const vendorRegisterURL = `${URL}vendor-register`
const categoryProduct = `${URL}category-products/`
const singleProductURL = `${URL}single-product/`
const addImageURL = `${URL}upload-image/`
const updateProductURL = `${URL}update-product/`
const allUserURL = `${URL}all-user`
const addUserUrl = `${URL}add-user`
const addCategory = `${URL}add-category`
const categoryImage =`${URL}cat-image/`
const brandImage = `${URL}brand-image/`
const InvoiceURL =`${URL}invoice/`
const adminLoginURL=`${URL}admin-login`
const adminRegisterURL=`${URL}admin-register`
const deleteProductURL =`${URL}delete-product/`
const brandProductURL = `${URL}brand-product/`
const addBrandURL = `${URL}add-brand`
const allBrand =`${URL}all-brand`
const deleteBrandURL = `${URL}delete-brand/`
const newcollectionsURL = `${URL}new-collection`
const editProductURL = `${URL}edit-product/`
const relatedProductURL = `${URL}related-product/`
const allProductURL = `${URL}all-products`
const budgetProductURL = `${URL}budget-products`
const midRangeProductURL = `${URL}mid-products`
const premiumProductURL = `${URL}premium-products`
const reviewURL = `${URL}review`




export{
    productsURL,
    registerURL,
    loginURL,
    addProductURL,
    categoryURL,
    ImageURL,
    prodcutReviewURL,
    addCartURL,
    CartURL,
    addOrderURL,
    orderURL,
    searchURL,
    vendorProductURL,
    addPaymentURL,
    deleteCart,
    updateCart,
    paymentURL,
    avatarURL,
    addAvatarURL,
    vendorUrl,
    addFavoriteUrl,
    favoriteUrl, 
    favoriteDelete,
    vendorRegisterURL,
    categoryProduct,
    singleProductURL,
    addImageURL,
    mainImageURI,
    ImagePathURI,
    allUserURL,
    addUserUrl,
    addCategory,
    categoryImage,
    InvoiceURL,
    adminLoginURL,
    adminRegisterURL,
    updateProductURL,
    deleteProductURL,
    brandProductURL,
    addBrandURL,
    allBrand,
    newcollectionsURL,
    brandImage,
    deleteBrandURL,
    editProductURL,
    relatedProductURL,
    allProductURL,
    budgetProductURL,
    midRangeProductURL,
    premiumProductURL,
    reviewURL,
    allAdminProductsURL,
    deleteOrderURL,

}  

